import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const TransactionStatusSuccessIcon: React.FC<SvgIconDefaultProps> = ({
  className,
  testId,
}) => {
  return (
    <CustomSvg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10 0C4.48603 0 0 4.48604 0 10C0 15.514 4.48603 20 10 20C15.514 20 20 15.514 20 10C20 4.48604 15.514 0 10 0ZM10 1.5C14.7033 1.5 18.5 5.2967 18.5 10C18.5 14.7033 14.7033 18.5 10 18.5C5.29669 18.5 1.5 14.7033 1.5 10C1.5 5.2967 5.29669 1.5 10 1.5ZM13.7354 6.99316C13.5406 6.99884 13.3556 7.0801 13.2197 7.21973L8.75 11.6895L6.78027 9.71973C6.71116 9.64775 6.62839 9.59028 6.53679 9.5507C6.4452 9.51111 6.34662 9.4902 6.24684 9.48918C6.14706 9.48817 6.04808 9.50707 5.9557 9.54479C5.86332 9.58251 5.77939 9.63828 5.70883 9.70883C5.63828 9.77939 5.58251 9.86332 5.54479 9.9557C5.50707 10.0481 5.48817 10.1471 5.48918 10.2468C5.4902 10.3466 5.51111 10.4452 5.5507 10.5368C5.59028 10.6284 5.64775 10.7112 5.71973 10.7803L8.21973 13.2803C8.36038 13.4209 8.55112 13.4999 8.75 13.4999C8.94888 13.4999 9.13962 13.4209 9.28027 13.2803L14.2803 8.28027C14.3885 8.1749 14.4623 8.03931 14.4922 7.89126C14.5221 7.7432 14.5066 7.58958 14.4477 7.4505C14.3888 7.31141 14.2893 7.19335 14.1622 7.11175C14.0351 7.03015 13.8863 6.98882 13.7354 6.99316Z"
        fill="#3B9F17"
      />
    </CustomSvg>
  );
};
export default TransactionStatusSuccessIcon;
